import * as _ from 'lodash';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { LegalRight } from 'helpers';
import { RetailerAndRights } from 'models/brand';

import { ApiModel } from './api.model';

@Injectable()
export class AccessModel {
    constructor(private apiModel: ApiModel) {}

    public request(organization: string, brand: string, requestedChannels: Array<string>) {
        return this.apiModel.makeHttpRequest({
            method: 'POST',
            url: `${this.apiModel.getAccessEndpoint()}/request`,
            body: {
                organization,
                brand,
                requestedChannels
            }
        });
    }

    public getRetailerRelations(
        brandIds: string[],
        legalRights?: LegalRight[]
    ): Observable<Omit<RetailerAndRights, 'categorizedRelations' | 'simplifiedName' | 'isEditing'>[]> {
        return this.apiModel.makeHttpObservableRequest({
            method: 'GET',
            url: `${this.apiModel.getAccessEndpoint()}/relations`,
            params: {
                brandId: brandIds,
                ...(_.isEmpty(legalRights) ? {} : { rights: legalRights })
            }
        });
    }
}
